const COMMUNITIES_CACHE_KEY = "chaperon_user_communities"
const USER_DATA_KEY = "chaperon_user_data"

export const PROFILE_PICTURE_CHANGED_EVENT = "profilePictureChanged"

const isSameUser = (person, userId) =>
    person?.type === "person" &&
    person.member_id != null &&
    String(person.member_id) === String(userId)

/**
 * Community members are cached in localStorage and only refetched every 10
 * minutes, so after an avatar upload the user's own entry would keep showing
 * the old photo. This patches the cached copies in place instead of
 * refetching every member.
 */
export const updateCachedProfilePicture = (userId, url) => {
    try {
        const cached = JSON.parse(
            localStorage.getItem(COMMUNITIES_CACHE_KEY) || "null",
        )
        if (Array.isArray(cached?.communities)) {
            cached.communities = cached.communities.map((community) => {
                if (!community.chaperees) return community

                const wasString = typeof community.chaperees === "string"
                const chaperees = wasString
                    ? JSON.parse(community.chaperees)
                    : community.chaperees
                if (!Array.isArray(chaperees)) return community

                const updated = chaperees.map((chaperee) =>
                    isSameUser(chaperee, userId)
                        ? { ...chaperee, profile_picture_url: url }
                        : chaperee,
                )
                return {
                    ...community,
                    chaperees: wasString ? JSON.stringify(updated) : updated,
                }
            })
            localStorage.setItem(COMMUNITIES_CACHE_KEY, JSON.stringify(cached))
        }
    } catch (error) {
        console.error("Failed to update cached community photos:", error)
    }

    try {
        const storedUser = JSON.parse(
            localStorage.getItem(USER_DATA_KEY) || "null",
        )
        if (storedUser) {
            localStorage.setItem(
                USER_DATA_KEY,
                JSON.stringify({ ...storedUser, profile_picture_url: url }),
            )
        }
    } catch (error) {
        console.error("Failed to update stored user photo:", error)
    }
}

/**
 * Call after a successful avatar upload: patches the caches, then notifies
 * mounted components (header menu, dashboard) so they update without a reload.
 */
export const announceProfilePicture = (userId, url) => {
    updateCachedProfilePicture(userId, url)
    window.dispatchEvent(
        new CustomEvent(PROFILE_PICTURE_CHANGED_EVENT, {
            detail: { userId, url },
        }),
    )
}
